import { useIntl } from "react-intl";

import { Button } from "@/components/Button";
import { IconLuggage } from "@/components/Icons";
import { RequiredLabel } from "@/features/flights/components/additional-services/RequiredLabel";
import { SelectedInfoBadge } from "@/features/flights/components/additional-services/SelectedInfoBadge";

type Props = {
  required?: boolean;
  selectedAmount?: number;
  onClick: () => void;
};

export const AddBaggageCard = ({
  required,
  selectedAmount,
  onClick,
}: Props) => {
  const intl = useIntl();

  return (
    <div className="relative flex flex-col rounded-3xl bg-white p-1">
      <div className="flex items-center gap-1 p-3">
        <IconLuggage className="size-18 shrink-0" />
        <div>
          <div className="font-medium text-text-primary">
            {intl.formatMessage({
              defaultMessage: "Add extra baggage",
              description:
                "Section heading for the extra baggage purchase add-on",
            })}
          </div>
          <div className="mb-1 text-sm text-text-tertiary">
            {intl.formatMessage({
              defaultMessage:
                "Carry more of your essentials without leaving anything behind",
              description:
                "Label or notice about options to carry additional luggage",
            })}
          </div>
          {selectedAmount && selectedAmount > 0 ? (
            <SelectedInfoBadge
              label={intl.formatMessage(
                {
                  defaultMessage:
                    "{amount, plural, one {# Extra baggage} other {# Extra baggages}} selected",
                  description:
                    "Count of additional baggage items selected for a traveller",
                },
                { amount: selectedAmount },
              )}
            />
          ) : (
            <SelectedInfoBadge
              label={intl.formatMessage({
                defaultMessage: "Nothing selected",
                description:
                  "Status label when no option has been selected (e.g. no meal, no service)",
              })}
              dimmed
            />
          )}
        </div>
      </div>
      <div className="p-3 pt-1">
        <Button variant="outlined" fullWidth onClick={onClick}>
          {selectedAmount && selectedAmount > 0
            ? intl.formatMessage({
                defaultMessage: "Edit baggage selection",
                description:
                  "Button to modify the extra baggage selection for a traveller",
              })
            : intl.formatMessage({
                defaultMessage: "Add extra baggage",
                description:
                  "Section heading for the extra baggage purchase add-on",
              })}
        </Button>
      </div>
      {required ? <RequiredLabel /> : null}
    </div>
  );
};
